/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Lists_DescriptionInputs */



/**
* | output |
* | --- |
* | "Build, fill, and price the wishlists and tradelists that power group trading, including per-card overrides and the three list kinds." |
*
* @param {Help_Article_Lists_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_lists_description = /** @type {((inputs?: Help_Article_Lists_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Lists_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstelle, fülle und bepreise die Wunsch- und Tauschlisten, auf denen der Tausch in Gruppen aufbaut, inklusive Karten-Ausnahmen und der drei Listenarten.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créez, remplissez et évaluez les listes de souhaits et les listes d'échange qui alimentent les échanges de groupe, y compris les exceptions par carte et les trois types de listes.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("建立、填充并定价支撑小组交换的心愿单和交换清单，包括单卡覆盖设置和三种清单类型。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("建立、填滿並定價支撐社團交換的願望清單與交換清單，包含單卡覆寫設定與三種清單類型。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("그룹 교환의 바탕이 되는 위시리스트와 교환 목록을 만들고, 채우고, 가격을 매기는 방법입니다. 카드별 설정과 세 가지 목록 종류도 다룹니다.")
	return /** @type {LocalizedString} */ ("Build, fill, and price the wishlists and tradelists that power group trading, including per-card overrides and the three list kinds.")
});